import classnames from 'classnames/bind'
import { HTMLAttributes } from 'react'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const HotSectionTitle = ({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cx('hot-section-title', className)} {...props}>
      {children}
    </div>
  )
}

export default HotSectionTitle
